import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { media } from "@mverissimoo/emotion-grid";
import { Breakpoint } from "../types";
import {
  black,
} from "shared/styles/colors";

export const RubikRegular = css({
  fontFamily: 'Rubik',
  fontWeight: 400,
});

export const RubikMedium = css({
  fontFamily: 'Rubik',
  fontWeight: 500,
});

export const RubikBold = css({
  fontFamily: 'Rubik',
  fontWeight: 700,
});

export const SpaceMonoRegular = css({
  fontFamily: 'Space Mono',
  fontWeight: 400,
});

export const SpaceMonoMedium = css({
  fontFamily: 'Space Mono',
  fontWeight: 500,
});

export const SpaceMonoBold = css({
  fontFamily: 'Space Mono',
  fontWeight: 700,
});

export const SpaceGroteskRegular = css({
  fontFamily: 'Space Grotesk',
  fontWeight: 400,
});

export const SpaceGroteskMedium = css({
  fontFamily: 'Space Grotesk',
  fontWeight: 500,
});

export const SpaceGroteskBold = css({
  fontFamily: 'Space Grotesk',
  fontWeight: 700,
});

export const H1 = styled.h1([
  SpaceMonoBold,
  {
    color: black,
    fontSize: 45,
    lineHeight: 1.24,
    [media(Breakpoint.md)]: {
      fontSize: 55,
    },
  },
]);
